import { Component, OnInit } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { IConnectionStatus } from '../../../store/IAppState';
import * as signalR from "@microsoft/signalr";
import { SignalrConnectionStatusService } from '../../services/signalr-connection-status.service';

@Component({
  selector: 'connection-banner',
  templateUrl: './connection-banner.component.html',
  styleUrls: ['./connection-banner.component.scss']
})
export class ConnectionBannerComponent implements OnInit {
  @select('connectionStatus') connectionStatus$: Observable<IConnectionStatus>;
  public HubConnectionState = signalR.HubConnectionState;

  constructor(private readonly connectionStatusService: SignalrConnectionStatusService) { }

  ngOnInit(): void {
  }

  refresh(): void {
    window.location.reload();
  }

  dismiss(status: IConnectionStatus): void {
    this.connectionStatusService.acknowledgeCurrentIncident(status);
  }
}
